import { DataGrid } from "devextreme-react";

import axios from "axios";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Lookup,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  classifAcademicBgd,
  classifAcademicBgdList,
  classifMajList,
  graduationStatus,
  graduationStatusList,
} from "./data";
import TwoDateBoxComponent2 from "./TwoDateBoxComponent2";

export default function EducationalHistory() {
  const [dataSource, setDataSource] = useState(null);
  const [classifAcademicBgdDataSource, setClassifAcademicBgdDataSource] =
    useState(
      new DataSource({
        store: classifAcademicBgdList,
        type: "array",
        key: "id",
      })
    );
  const [schDataSource, setSchDataSource] = useState(null);
  const [graduationStatusDataSource, setGraduationStatusDataSource] = useState(
    new DataSource({
      store: graduationStatusList,
      type: "array",
      key: "id",
    })
  );
  const [formDataSource, setFormDataSource] = useState(null);
  const [majDataSource, setMajDataSource] = useState(null);
  const [classifMajDataSource, setClassifMajDataSource] = useState(null);

  // const [classifAcademicBgd, setClassifAcademicBgd] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const educationalHistoryGridRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  useEffect(async () => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/eduHis/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          values = {
            ...values,
            otrClassifAcademicBgd:
              values.classifAcademicBgd == "9"
                ? classifAcademicBgdDataSource
                    .items()
                    .find((item) => item.id == "9").name
                : null,
            otrGraduationStatus:
              values.graduationStatus == "9"
                ? graduationStatusDataSource
                    .items()
                    .find((item) => item.id == "9").name
                : null,
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
          };

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/eduHis/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          values = {
            ...values,
            otrClassifAcademicBgd:
              values.classifAcademicBgd == "9"
                ? classifAcademicBgdDataSource
                    .items()
                    .find((item) => item.id == "9").name
                : null,
            otrGraduationStatus:
              values.graduationStatus == "9"
                ? graduationStatusDataSource
                    .items()
                    .find((item) => item.id == "9").name
                : null,
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
          };

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/eduHis/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/eduHis/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );

    // setClassifAcademicBgdDataSource(
    //   new DataSource({
    //     store: classifAcademicBgdList,
    //     type: "array",
    //     key: "id",
    //   })
    // );

    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/eduHis/school`
    );

    // setSchDataSource(
    //   new DataSource({
    //     store: result.data,
    //     type: "array",
    //     key: "id",
    //   })
    // );
    setSchDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "id",
        },
      })
    );

    // setGraduationStatusDataSource(
    //   new DataSource({
    //     store: graduationStatusList,
    //     type: "array",
    //     key: "id",
    //   })
    // );

    const result2 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/eduHis/class`
    );

    setMajDataSource(
      new DataSource({
        store: {
          data: result2.data,
          type: "array",
          key: "majorSeq",
        },
        group: "lClass",
      })
    );

    setClassifMajDataSource(
      new DataSource({
        store: classifMajList,
        type: "array",
        key: "id",
      })
    );
  }, []);

  // useEffect(() => {
  //   if (classifAcademicBgd) {
  //     console.debug("[useEffect]");
  //     console.debug("classifAcademicBgd", classifAcademicBgd);
  //   }
  // }, [classifAcademicBgd]);

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newClassifAcademicBgd = {
      id: "9",
      name: args.text,
    };

    args.customItem = classifAcademicBgdDataSource
      .store()
      .insert(newClassifAcademicBgd)
      .then(() => classifAcademicBgdDataSource.load())
      .then(() => newClassifAcademicBgd)
      .catch((error) => {
        throw error;
      });
  };

  const onCustomGraduationStatusItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newGraduationStatus = {
      id: "9",
      name: args.text,
    };

    args.customItem = graduationStatusDataSource
      .store()
      .insert(newGraduationStatus)
      .then(() => graduationStatusDataSource.load())
      .then(() => newGraduationStatus)
      .catch((error) => {
        throw error;
      });
  };

  const setCellValue = (newData, value) => {
    newData.classifAcademicBgd = value;

    // setClassifAcademicBgd(value);
  };

  const customizeItem = (item) => {
    if (item) {
      let gridInstance = educationalHistoryGridRef.current.instance;
      let editRowKey = gridInstance.option("editing.editRowKey");
      let index = gridInstance.getRowIndexByKey(editRowKey);
      index = index === -1 ? 0 : index;

      const classifAcademicBgd = gridInstance.cellValue(
        index,
        "classifAcademicBgd"
      );

      if (item.dataField == "sch") {
        if (classifAcademicBgd) {
          if (classifAcademicBgd == 1) {
            schDataSource.filter([
              ["schoolGubun", "=", "자율고"],
              "or",
              ["schoolGubun", "=", "일반고"],
              "or",
              ["schoolGubun", "=", "특성화고"],
              "or",
              ["schoolGubun", "=", "특수목적고"],
            ]);
          } else if (classifAcademicBgd == 2) {
            schDataSource.filter(["schoolGubun", "=", "전문대학"]);
          } else {
            schDataSource.filter(["schoolGubun", "=", "대학(4년제)"]);
          }

          schDataSource.load();
        }
      }

      if (
        item.dataField == "maj" ||
        item.dataField == "majRqdC" ||
        item.dataField == "classifMaj" ||
        item.dataField == "minor" ||
        item.dataField == "minorRqdC" ||
        item.dataField == "grd"
      ) {
        if (classifAcademicBgd == "1") {
          item.visible = false;
          item.disabled = true;
        }
      }
    }
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.schoolName} ${item.adres ? "(" + item.adres + ")" : ``}`;
    } else {
      return null;
    }
  };

  const calculateDisplayValue = (data) => {
    if (data.classifAcademicBgd != "9") {
      return classifAcademicBgd[data.classifAcademicBgd];
    } else {
      return data.otrClassifAcademicBgd;
    }
  };

  const calculateGraduationStatusDisplayValue = (data) => {
    if (data.graduationStatus != "9") {
      return graduationStatus[data.graduationStatus];
    } else {
      return data.otrGraduationStatus;
    }
  };

  const onEditingStart = (e) => {
    if (e.data.startDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        startDate: e.data.startDate,
      }));
    }

    if (e.data.endDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        endDate: e.data.endDate,
      }));
    }
  };

  const onInitNewRow = (e) => {
    const key = educationalHistoryGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data =
        educationalHistoryGridRef.current.instance.getSelectedRowsData()[0];

      if (e.data.startDate) {
        setFormDataSource((prevState) => ({
          ...prevState,
          startDate: e.data.startDate,
        }));
      }

      if (e.data.endDate) {
        setFormDataSource((prevState) => ({
          ...prevState,
          endDate: e.data.endDate,
        }));
      }
    }
  };

  return (
    <DataGrid
      id="educationalHistoryGrid"
      ref={educationalHistoryGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onEditingStart={onEditingStart}
      onInitNewRow={onInitNewRow}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Educational History"}
          confirmDeleteMessage="Are you sure you want to delete this educational history?"
        />
        <Popup title={"Educational History"} showTitle={true} height={350} />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="educationalHistory"
          height={"100%"}
          customizeItem={customizeItem}
        >
          <SimpleItem
            dataField={"classifAcademicBgd"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: classifAcademicBgdDataSource,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomItemCreating,
            }}
          >
            <Label text={"학력구분"} />
            <RequiredRule message={"* 학력구분을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"sch"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: schDataSource,
              valueExpr: "id",
              displayExpr: displayExpr,
              showClearButton: true,
              // placehoder: "직접입력가능",
              searchEnabled: true,
              searchMode: "contains",
              searchExpr: "schoolName",
              searchTimeout: 200,
              minSearchLength: 0,
              showDataBeforeSearch: false,
              // acceptCustomValue: true
            }}
          >
            <Label text={"학교명"} />
            <RequiredRule message={"* 학교명을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"graduationStatus"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: graduationStatusDataSource,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomGraduationStatusItemCreating,
            }}
          >
            <Label text={"졸업상태"} />
            <RequiredRule message={"* 졸업상태를 입력해주세요."} />
          </SimpleItem>
          <SimpleItem>
            <Label text={"재학기간"} />
            <TwoDateBoxComponent2
              firstDateBox={{
                placeholder: "입학일",
                field: "startDate",
                ref: startDateRef,
              }}
              secondDateBox={{
                placeholder: "졸업일",
                field: "endDate",
                ref: endDateRef,
              }}
              formDataSource={formDataSource}
            />
          </SimpleItem>
          <SimpleItem
            dataField="maj"
            editorType={"dxSelectBox"}
            editorOptions={{
              dataSource: majDataSource,
              valueExpr: "majorSeq",
              displayExpr: "mClass",
              showClearButton: true,
              searchEnabled: true,
              searchMode: "contains",
              searchExpr: "mClass",
              searchTimeout: 200,
              minSearchLength: 0,
              showDataBeforeSearch: false,
              grouped: true,
            }}
          >
            <Label text={"주전공 및 학위(전공계열)"} />
            <RequiredRule
              message={"* 주전공 및 학위(전공계열)를 입력해주세요."}
            />
          </SimpleItem>
          <SimpleItem
            dataField={"majRqdC"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
            colSpan={3}
          >
            <Label text="주전공 이수과목 또는 연구내용 (선택)" />
          </SimpleItem>
          <SimpleItem
            dataField={"classifMaj"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: classifMajDataSource,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"전공구분"} />
          </SimpleItem>
          <SimpleItem
            dataField={"minor"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: majDataSource,
              valueExpr: "majorSeq",
              displayExpr: "mClass",
              showClearButton: true,
              searchEnabled: true,
              searchMode: "contains",
              searchExpr: "mClass",
              searchTimeout: 200,
              minSearchLength: 0,
              showDataBeforeSearch: false,
              grouped: true,
            }}
          >
            <Label text={"부/이중 전공 및 학위 (전공계열)"} />
          </SimpleItem>
          <SimpleItem
            dataField={"minorRqdC"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text="부/이중 전공 이수과목 또는 연구내용 (선택)" />
          </SimpleItem>
          <SimpleItem
            dataField={"grd"}
            editorType="dxNumberBox"
            editorOptions={{
              showClearButton: true,
              format: "#.#0",
              max: 4.5,
            }}
          >
            <Label text={"학점"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column
        dataField={"classifAcademicBgd"}
        caption="학력구분"
        setCellValue={setCellValue}
        calculateDisplayValue={calculateDisplayValue}
      />
      <Column
        dataField={"otrClassifAcademicBgd"}
        caption="기타 학력구분"
        visible={false}
      />
      <Column dataField={"sch"} caption="학교명" visible={false} />
      <Column dataField={"schoolName"} caption="학교명" />
      <Column
        dataField={"graduationStatus"}
        caption="졸업상태"
        calculateCellValue={calculateGraduationStatusDisplayValue}
      />
      <Column
        dataField={"otrGraduationStatus"}
        caption="기타 졸업상태"
        visible={false}
      />
      <Column
        dataField={"startDate"}
        caption="입학일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField={"endDate"}
        caption="졸업일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField={"maj"}
        caption="주전공 및 학위(전공계열)"
        visible={false}
      />
      <Column dataField={"majClass"} caption="주전공 및 학위(전공계열)" />
      <Column
        dataField={"majRqdC"}
        caption="주전공 이수과목 또는 연구내용 (선택)"
      />
      <Column dataField={"classifMaj"} caption="전공구분">
        <Lookup
          dataSource={classifMajList}
          valueExpr="id"
          displayExpr={"name"}
        />
      </Column>
      <Column
        dataField={"minor"}
        caption="부/이중 전공 및 학위 (전공계열)"
        visible={false}
      />
      <Column
        dataField={"minorClass"}
        caption="부/이중 전공 및 학위 (전공계열)"
      />
      <Column
        dataField={"minorRqdC"}
        caption="부/이중 전공 이수과목 또는 연구내용 (선택)"
      />
      <Column dataField={"grd"} caption="학점" />
    </DataGrid>
  );
}
